
// Library imports.
import axios, { AxiosResponse } from "axios";
import {baseWorker} from "../baseWorker";

// App imports.
import { config } from "../config";
import axiosInstance from '../axiosInstance';

export enum GuidedSearchReportTypes {
     nationalReports = 'NATL',
     stateComparison = 'COMP',
     singleState = 'SNGL',
}

export interface IGuidedSearchReportCategories {
     categoryDesc: string
     , categoryIcon: string
     , categoryToolTip: string
     , reports: IGuidedSearchReport[]
}

export interface IGuidedSearchReport {
     reportName: string
     , reportId:number
     , getRegionFlag: boolean
     , reportTitle: string
     , reportSubTitle: string
     , reportToolTip: string
     , reportDescription: string
     , years: number
     , graphIcon: string
     , graphCode: string
     , graphTypeDescription: string
     , getRegion:boolean
     , fields:string
}


export class ReportWorker extends baseWorker {

     public async getGuidedSearchReports(reportTypeSelected: string): Promise<IGuidedSearchReportCategories[]> {
          //pass parameter in FormData object because Php expects form encoded POST
          const formData = new FormData();
          formData.append("reportType", reportTypeSelected);
          
          const response: AxiosResponse =
               await axiosInstance.get(`${config.apiBaseURL}/search/guided/reports/${reportTypeSelected}`);               
          let results: IGuidedSearchReportCategories[] = [];
          response.data.forEach(r => {
               results.push({
                    categoryDesc: r.categoryDesc
                    , categoryIcon: r.categoryIcon
                    , categoryToolTip: r.categoryToolTip
                    , reports: r.reports
               });
          });
          return results;
     }
}
